import React, { useEffect, useRef, memo } from 'react';
import * as Sentry from '@sentry/browser';
import { hot } from 'react-hot-loader';

const areEqual = (prevProps, { shippingHTML }) => {
	if (shippingHTML === prevProps.shippingHTML) return true;
	return false;
};

const Ingrid = ({ shippingHTML, centraCheckoutScript, ingridLoaded, ingridUnloaded, token }) => {
	const shippingForm = useRef(null);
	const ingridFinishedLoading = useRef(false);

	useEffect(() => {
		ingridLoaded();

		// eslint-disable-next-line no-underscore-dangle
		if (shippingForm.current && !window._sw) {
			if (shippingForm.current.querySelector('script')) {
				// Insert checkout form.
				const scriptContents = shippingForm.current.querySelector('script').innerHTML;
				const d = document.createElement('script');
				d.text = scriptContents;
				d.id = 'ingridScript';
				document.body.appendChild(d);
			}
		}

		// eslint-disable-next-line no-underscore-dangle
		if (centraCheckoutScript && window.CentraCheckout === undefined) {
			const addCheckoutScript = document.createElement('script');
			addCheckoutScript.text = centraCheckoutScript;
			addCheckoutScript.id = 'centraCheckoutScript';
			document.body.appendChild(addCheckoutScript);

			window._sw((api) => { // eslint-disable-line no-underscore-dangle
				api.on('data_changed', () => {
					ingridFinishedLoading.current = true;
				});
				api.on('loaded', () => {
					ingridFinishedLoading.current = true;
				});
			});
		}

		const timeout1 = setTimeout(() => {
			if (ingridFinishedLoading.current === false) {
				console.log('DEBUG: INGRID STILL LOADING', 3000);
				Sentry.withScope((scope) => {
					scope.setContext('customer', { token, time: 3000 });
					Sentry.captureMessage('INGRID STILL LOADING');
				});
			}
		}, 3000);

		const timeout2 = setTimeout(() => {
			if (ingridFinishedLoading.current === false) {
				console.log('DEBUG: INGRID STILL LOADING', 6000);
				Sentry.withScope((scope) => {
					scope.setContext('customer', { token, time: 6000 });
					Sentry.captureMessage('INGRID STILL LOADING');
				});
			}
		}, 6000);

		const timeout3 = setTimeout(() => {
			if (ingridFinishedLoading.current === false) {
				console.log('DEBUG: INGRID STILL LOADING', 9000);
				Sentry.withScope((scope) => {
					scope.setContext('customer', { token, time: 9000 });
					Sentry.captureMessage('INGRID STILL LOADING');
				});
			}
		}, 9000);

		return () => {
			console.log('DEBUG: cleared');
			clearTimeout(timeout1);
			clearTimeout(timeout2);
			clearTimeout(timeout3);
			ingridUnloaded();
		};
	}, [shippingHTML]);

	return (
		<div id="ingridContainer" ref={shippingForm} dangerouslySetInnerHTML={{ __html: shippingHTML }} />
	);
};

export default hot(module)(memo(Ingrid, areEqual));
